import request from '@/utils/request'

const prefix = '/django_rest/job-profile'

export default {
  getJobInfoById (jobId) {
    return request.get(`${prefix}/${jobId}`)
  },
  createJob (jobInfo) {
    return request.post(`${prefix}/`, jobInfo)
  },
  updateJob (jobId, jobInfo) {
    return request.put(`${prefix}/${jobId}`, jobInfo)
  },
  getJobLocationList (params) {
    return request.get('/django_rest/company/job/location/', { params })
  }
}
